module.exports = __webpack_public_path__ + "static/media/section-deals-disabled.a62bb5d8.svg";